<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="lock-password-input"
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
  >
    <g id="Group_1072" data-name="Group 1072" transform="translate(5.81 3.488)">
      <path
        id="Path_8498"
        data-name="Path 8498"
        d="M19,22.837H7.325A2.333,2.333,0,0,1,4.992,20.5c-.012-.012-.012-.012,0-.012V12.325l-.012-.012A2.315,2.315,0,0,1,7.3,9.98H18.957A2.313,2.313,0,0,1,21.278,12.3h0v8.167h0a2.33,2.33,0,0,1-2.333,2.322.011.011,0,0,1-.012-.012Z"
        transform="translate(-4.98 -1.825)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_8499"
        data-name="Path 8499"
        d="M12.7,17.538h0a.056.056,0,0,1,0,.082.071.071,0,0,1-.093,0c-.035-.035-.035-.07-.012-.093v-.012h0V17.5a.045.045,0,0,1,.082,0m4,1.832v-3.5M8,11.168v-3.5H7.99A4.68,4.68,0,0,1,12.645,2.99h0a4.68,4.68,0,0,1,4.667,4.667h0v3.5M8.69,17.538h0a.056.056,0,0,1,0,.082.071.071,0,0,1-.093,0c-.035-.035-.035-.07-.012-.093v-.012h0V17.5a.045.045,0,0,1,.082,0"
        transform="translate(-4.478 -2.99)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
    <path id="Path_8500" data-name="Path 8500" d="M0,0H28V28H0Z" fill="none" />
  </svg>
</template>
